import React, { useState } from "react";
import styles from "./AddGroup.module.css";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DeleteResult from "../Members/MemberDetail/DeleteResult";
import { useForm } from "react-hook-form";
import TrainzaApi from "../../Helpers/Api";
import { STATUS_CODE } from "../../Utils/StatusCode";
import { STATUS_MSG } from "../../Utils/StatusMsg";
import Toster from "../../Common/Toster/Toster";
import { userLogoutClear } from "../../redux/slices/userSlice";
import Loader from "../../Common/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton } from "../../ReactBootstrap/CustomTabButton";
import { CustomInputField } from "../../ReactBootstrap/CustomInputField/CustomInputField";

function AddGroup({ setShowtab }) {
  const { register, handleSubmit, formState, reset, setValue } = useForm({
    mode: "onChange",
  });

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.user.userTokenTrainzaBrand
  );

  const [isLoading, setIsLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const handleDelete = () => {
    setShowDelete(!showDelete);
  };

  function OnSubmit(data) {
    const PostData = new FormData();

    PostData.append("name", data.GROUP_NAME);
    PostData.append("subtitle", data.SUBTITLE);
    PostData.append("aboutInfo", data.ABOUT_INFO);

    setIsLoading(true);
    TrainzaApi.addGroup(isAuthenticated, PostData).then((response) => {
      setIsLoading(false);

      const ResponseCode = STATUS_MSG[response?.data?.code];

      if (
        response?.data?.code === STATUS_CODE.INVALID_TOKEN ||
        response?.data?.code === STATUS_CODE.SESSION_EXPIRED
      ) {
        dispatch(userLogoutClear());
        Toster(t("SESSION_EXPIRED"), "error");
      } else {
        if (response?.code === STATUS_CODE.SUCCESS) {
          Toster(t("GROUP_ADDED_SUCCESSFULLY"), "success");

          setShowtab(1);
          reset();
        } else if (response?.data?.code == STATUS_CODE.VALIDATION_ERROR) {
          Toster(response?.data?.message, "error");
        } else {
          Toster(t(ResponseCode), "error");
        }
      }
    });
  }

  const handleKeyPress = (e, t) => {
    if (e.target.value == " ") setValue(e.target.name, e.target.value.trim());
  };

  return (
    <div>
      {isLoading && <Loader />}
      <div className={styles.MainBox}>
        <div className={styles.headingBox}>
          <p>
            {t("ADD")}
            <span> {t("TRAINING_GRP")}</span>
          </p>
        </div>
        <Form onSubmit={handleSubmit(OnSubmit)}>
          <div className={styles.inputArea}>
            <CustomInputField
              styleName="inputTextForAddGroup"
              type="text"
              PlaceHolder={t("INPUT_GRP_NAME")}
              RegisterName={"GROUP_NAME"}
              register={register}
              formState={formState}
              onChange={(e) => {
                handleKeyPress(e);
              }}
            >
              <p>{t("GRP_NAME")}</p>
            </CustomInputField>

            <CustomInputField
              styleName="inputTextForAddGroup"
              type="text"
              PlaceHolder={t("INPUT_SUBTITLE")}
              RegisterName={"SUBTITLE"}
              register={register}
              formState={formState}
              onChange={(e) => {
                handleKeyPress(e);
              }}
            >
              <p>{t("SUBTITLE_GRP_TRAINER_OPTIONAL")}</p>
            </CustomInputField>

            <CustomInputField
              styleName="inputTextForAddGroup"
              as="textarea"
              type="text"
              PlaceHolder={t("OPTONAL_DESCRIPTION")}
              RegisterName={"ABOUT_INFO"}
              register={register}
              formState={formState}
              onChange={(e) => {
                handleKeyPress(e);
              }}
            >
              <p>{t("ABOUT_INFO")}</p>
            </CustomInputField>
          </div>

          <div className={styles.btnArea}>
            <div className={styles.cancelAndDeleteBtn}>
              <CustomButton
                variant={"cancelBtn"}
                type="button"
                onClick={() => setShowtab(1)}
              >
                {t("CENCEL")}
              </CustomButton>
            </div>

            <CustomButton variant="footerBtnCustom" type="submit">
              <p>
                {t("ADD")} <span>{t("GROUP")}</span>
              </p>
            </CustomButton>
          </div>
        </Form>
      </div>
      <DeleteResult
        show={showDelete}
        handleClose={handleDelete}
        isLoading={isLoading}
      />
    </div>
  );
}

export default AddGroup;
